import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IPermPostJobTermsAddendumViewedPayload {
  postingId: string;
}

/**
 * Fires when the terms and conditions addendum popup is viewed after job submission
 * Only shown if user has not previously accepted terms
 * Event: dental_portal:perm_post_job:terms_addendum_viewed
 */
export function firePermPostJobTermsAddendumViewed(
  payload: IPermPostJobTermsAddendumViewedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:terms_addendum_viewed', {
    posting_id: payload.postingId,
  });
}